// import { child, get, ref } from 'firebase/database'
import { ref, getDoc, collection, doc } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'
import { toast } from 'react-toastify'
import PageContainer from '../../Components/PageContainer'
import { Meta } from '../../Components/Poll'
import { auth, database, firestore } from '../../firebase'
import cloudFunctions from '../../Helpers/cloudFunctions'
import ReactSoundCloud from 'react-soundcloud-embedded'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import Rank from './Types/Rank'
import Normal from './Types/Normal'
import Slider from './Types/Slider'
import Fade from 'react-reveal/Fade';
import { EmbedRenderer } from '../../Components/EmbedRenderer'
import TagsCollection from '../../Components/PopularTags'
import Spinner from '../../Components/Spinner'

export default function Poll({ privatePoll }) {
    const { pollID } = useParams()
    const [poll, setPoll] = useState(null)
    const [fourOfour, setFourOfour] = useState(false)
    const [showResults, setShowResults] = useState(false)
    const [user, setUser] = useState(null)
    const navigate = useNavigate()
    const fetchAndSetPollData = async () => {
        // const dbRef = ref(database)
        const docRef = doc(firestore, privatePoll ? "privatePolls" : "polls", pollID)
        await getDoc(docRef).then((snap) => {
            if (snap.exists()) {
                setPoll(snap.data())
            } else {
                setFourOfour(true)
            }
        })
    }
    useEffect(() => {
        fetchAndSetPollData()
    }, [])
    useEffect(() => {
        if (poll) {
            cloudFunctions.getUser({ uid: poll.posterID }).then((res) => {
                setUser({ ...res.data })
            })
        }
    }, [poll])
    useEffect(() => {
        if (poll) {
            if (poll.voters) {
                for (let i = 0; i < poll.voters.length; i++) {
                    if (poll.voters[i] === auth.currentUser?.uid) {
                        setShowResults(true)
                    }
                }
            }
            if (Date.now() > poll.expiryDate && poll.expiryDate !== false) {
                setShowResults(true)
            } else if (poll.voterCountLimit !== false && poll.votersCount >= poll.voterCountLimit) {
                setShowResults(true)
            }
        }
    }, [poll])
    const PollInteractionRenderer = () => {
        const [totalVotes, setTotalVotes] = useState(0)
        useEffect(() => {
            if (poll.options) {
                let voteCount = 0
                for (let i = 0; i < poll.options.length; i++) {
                    voteCount = voteCount + poll.options[i].votes
                    if (i + 1 === poll.options.length) {
                        setTotalVotes(voteCount)
                    }
                }
            }
        }, [])
        if (poll.type === "normal") {
            return <Normal privatePoll={privatePoll} cta={poll.cta} totalVotes={totalVotes} poll={poll} showResults={showResults} fetchAndSetPollData={fetchAndSetPollData} pollID={pollID} />

        } else if (poll.type === "rank") {
            return <Rank privatePoll={privatePoll} cta={poll.cta} poll={poll} pollID={pollID} showResults={showResults} fetchAndSetPollData={fetchAndSetPollData} />
        } else if (poll.type === "slider") {
            return <Slider privatePoll={privatePoll} cta={poll.cta} poll={poll} showResults={showResults} fetchAndSetPollData={fetchAndSetPollData} pollID={pollID} />
        }
    }
    const UserRenderer = () => {
        return (
            <Fade bottom duration={300}>
                <div className='flex aic' style={{ gap: 7, cursor: "pointer" }} onClick={() => navigate(`/account/${poll.posterID}`)}>
                    {user?.photoURL
                        ? <img src={user.photoURL} referrerpolicy="no-referrer" className="mini-pfp" />
                        : <img src={`https://ui-avatars.com/api/?background=0074D9&color=fff&name=${user?.displayName}`} referrerPolicy="no-referrer" className="mini-pfp noBorder" alt="Profile picture" />
                    }
                    <h3 style={{ fontSize: 15, margin: 0, opacity: .6 }} className='usrProfileTextHeader'>{user?.displayName}</h3>
                </div>
            </Fade>
        )
    }
    const StatisticRenderer = () => {
        const [statistics, setStatistica] = useState(null)
        const [totals, setTotals] = useState(null)

        const Stat = ({ index }) => {
            const Breakdown = () => {
                const [brdwn, setBrdwn] = useState([])
                const Bar = ({ label, value }) => {
                    return (
                        <div className='flex aic' style={{ gap: 10, marginLeft: 20 }}>
                            <p style={{ margin: 0, fontWeight: 600, opacity: .6 }}>{label}</p>
                            <progress max={100} value={value}></progress>
                            <p style={{ fontSize: 12 }}>{value}%</p>
                        </div>
                    )
                }
                useEffect(() => {
                    let newBreakdown = new Object()
                    for (const x in statistics[index]) {
                        newBreakdown = { ...newBreakdown, [x]: (statistics[index][x] / totals[index]) * 100 }
                    }
                    setBrdwn(newBreakdown)
                }, [])
                return (
                    <>
                        {Object.keys(brdwn).map((bar) => {
                            return (
                                <Bar label={bar == "undefined" ? "Unknown" : bar} value={brdwn[bar]} />
                            )
                        })}
                        {!Object.keys(brdwn).length
                            ? <p style={{ margin: 0, fontWeight: 600, opacity: .6, marginLeft: 20 }}>NO DATA</p>
                            : null
                        }
                    </>
                )
            }
            return (
                <div className='flex fdc' style={{ gap: 10, marginBottom: 10 }}>
                    <p style={{ fontWeight: "bold", marginBottom: 0 }}>{index.toUpperCase()}</p>
                    <Breakdown />
                </div>
            )
        }
        const getAnalytics = () => {
            setStatistica(null)
            setTotals(null)
            cloudFunctions.getAnalytics({
                pollID: pollID,
                private: privatePoll
            }).then((res) => {
                setStatistica(res.data.data)
                let newTotals = new Object()
                for (const x in res.data.data) {
                    let subTotal = 0
                    for (const y in res.data.data[x]) {
                        subTotal = subTotal + res.data.data[x][y]
                    }
                    newTotals = { ...newTotals, [x]: subTotal }
                }
                setTotals(newTotals)
            })
        }
        useEffect(() => {
            if (poll.pollAnalytics) {
                if (poll.posterID === auth.currentUser?.uid) {
                    getAnalytics()
                }
            }
        }, [])
        if (poll.pollAnalytics && poll.posterID === auth.currentUser?.uid) {
            if (statistics) {
                return (
                    <Fade>
                        <div style={{ margin: "40px 0", border: "2px solid rgba(0,0,0,.1)", borderRadius: 10, padding: 20, marginTop: 20 }} className="bb">
                            <div className='flex aic jcsb'>
                                <h3 style={{ margin: 0 }}>Statistics</h3>
                                <button className='b4' onClick={getAnalytics}>Refresh</button>
                            </div>
                            <div style={{ height: 2, width: "100%", background: "rgba(0,0,0,.1)", marginTop: 16 }} />
                            {Object.keys(statistics).map((stat) => {
                                return <Stat index={stat} />
                            })}
                        </div>
                    </Fade>
                )
            } else {
                return (
                    <Spinner />
                )
            }
        } else {
            return null
        }
    }
    if (poll && user) {
        return (
            <PageContainer>
                <div style={{ padding: "0 30px", overflow: "visible" }} className="pgePadd">
                    <div className='flex aic' style={{ gap: 5, marginTop: 30, cursor: "pointer" }} onClick={() => navigate(-1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" opacity=".87" /><path d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z" /></svg>
                        <p style={{ fontWeight: "bold" }}>Back</p>
                    </div>
                    <div style={{ background: "#fff", padding: 30, borderRadius: 20, marginTop: 20, overflow: 'visible' }}>
                        <div style={{ marginTop: 0 }}>
                            <UserRenderer />
                            <Meta {...poll} style={{ marginTop: 5 }} />
                            {poll && user
                                ? <StatisticRenderer />
                                : null
                            }
                        </div>
                        <h1 style={{ marginBottom: 0, marginTop: 0 }}>{poll.title}</h1>
                        <p style={{ opacity: .6, fontWeight: 600, marginTop: 10 }}>
                            {poll.description}
                        </p>
                        <div style={{ marginBottom: 10 }}>
                            {poll.mediaLink
                                ? <EmbedRenderer poll={poll} />
                                : null
                            }
                        </div>
                        <div className='flex aic jcsb' style={{ marginBottom: 0 }}>
                            <div className='pollPageTagContainer'>
                                <TagsCollection noPad
                                    tags={poll.tags}
                                />
                            </div>
                        </div>
                    </div>

                    <div style={{ marginTop: 30, overflow: "visible" }}>
                        <PollInteractionRenderer />
                    </div>
                    {!auth.currentUser
                        ? <>
                            <div style={{ marginTop: 20, gap: 20 }} className="flex aic jcsb">
                                <div style={{ flex: 1, height: 3, background: "rgba(0,0,0,.1)" }} />
                                <p style={{ fontWeight: 600, fontSize: 15, opacity: .6, margin: 0 }}>Authenticate to vote in polls</p>
                                <div style={{ flex: 1, height: 3, background: "rgba(0,0,0,.1)" }} />
                            </div>
                            <div className='flex aic jcsb' style={{ gap: 20, marginTop: 20 }}>
                                <button className='b5' onClick={() => navigate("/signup")}>Sign Up</button>
                                <p style={{ fontWeight: 700, opacity: .5, fontSize: 17 }}>or</p>
                                <button className='b6' onClick={() => navigate("/login")}>Login</button>
                            </div>
                        </>
                        : null
                    }
                </div>
            </PageContainer>
        )
    } else {
        if (fourOfour) {
            return (
                <div style={{ width: "100%", minHeight: 300, opacity: .6, gap: 10 }} className="flex aic jcc">
                    <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" width="30px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" /></svg>                    <h2>Poll not found (404)</h2>
                </div>
            )
        } else {
            return <Spinner />
        }
    }
}
